import Submission from './submission';
import Landing from './landing';

var Recovery = {
	Submission,
	Landing
}

export default Recovery;


// WEBPACK FOOTER //
// ./src/browser/components/recovery/recovery.js